import { render, staticRenderFns } from "./AppFeatureTabs.vue?vue&type=template&id=7adcf6a9&scoped=true"
import script from "./AppFeatureTabs.vue?vue&type=script&lang=js"
export * from "./AppFeatureTabs.vue?vue&type=script&lang=js"
import style0 from "./AppFeatureTabs.vue?vue&type=style&index=0&id=7adcf6a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adcf6a9",
  null
  
)

export default component.exports